<template>
  <div>
    <v-layout row wrap justify-end align-end>
      <download-excel
        class="v-btn v-btn--floating v-btn--small theme--dark primary"
        :data="filteredData"
        :fields="fields"
        name="reporteFirmas.xls"
      >
        <v-icon color="white">cloud_download</v-icon>
      </download-excel>
    </v-layout>
    <v-toolbar flat color="white">
      <v-toolbar-title>Reporte de documentos firmados</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-layout row wrap>
        <v-flex mr-3 xs12 sm5>
          <v-select
            :items="sign_dates"
            v-model="filter_sign"
            label="Filtrar Fecha de firma"
            item-text="description"
            item-value="id"
            clearable
            @change="setFilter"
          ></v-select>
        </v-flex>
        <v-flex xs12 sm5>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-toolbar>
    <v-data-table
      :headers="tableHeaders"
      :items="filteredData"
      :search="search"
    >
      <template slot="items" slot-scope="props">
        <td
          v-for="(head, i) in tableHeaders"
          :key="`t-${i}`"
          class="text-xs-center"
        >
        <span v-if="!head.document">
          {{ props.item[head.value] }}
        </span>
        <span
          v-else
          style="cursor:pointer;"
        >
          <v-icon
            v-if="props.item[`status-${head.value}`] == 'not_assigned'"
            medium
            color="grey"
          >
            remove_circle
          </v-icon>
          <span v-else>
            <v-icon
              v-if="props.item[`status-${head.value}`] == 'F'"
              medium
              color="success"
              @click="loadDocument(props.item[`doc_id-${head.value}`])"
            >
              check_circle
            </v-icon>
            <v-icon
              v-else-if="props.item[`status-${head.value}`] == 'P'"
              medium
              color="warning"
            >
              info
            </v-icon>
            <v-icon
              v-else
              medium
              color="error"
            >
              highlight_off
            </v-icon>
          </span>
        </span>
        </td>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialogDigitalSign"
      fullscreen>
      <digital-sign-comp
        v-on:closeDialog="closeSignDialog"
        :studentId="''"
        :documentId="0"
        :action="action"
        :processId="0"
        :recordId="vista_record_id"
      ></digital-sign-comp>
    </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  import JsonExcel from 'vue-json-excel'
  import DigitalSignComponent from './digital_sign'
  export default {
    name: 'family-sign-report',
    components: {
      'digital-sign-comp': DigitalSignComponent,
      'download-excel': JsonExcel,
    },
    data() {
      return {
        sign_dates: [],
        filter_sign: '',
        signDateEmployees: [],
        students: [],
        documents: [],
        tableHeaders: [],
        tableData: [],
        search: '',
        dialogDigitalSign: false,
        vista_record_id: 0,
        action: '',
        fields: {},
      }
    },
    computed: {
      filteredData() {
        let data = this.tableData

        if (this.filter_sign && this.filter_sign !== '') {

        }

        return data
      }
    },
    created () {
      this.init();
    },
    methods: {
      init() {
        axios.get(`/api/documents/sign_date/families/report`)
          .then(resp => {
            if (resp.status === 200) {
              this.signDateEmployees = resp.data.sign_date_employees
              this.students = resp.data.students
              this.documents = resp.data.documents
              this.setData()
            }
          })
          .catch(err => console.log(err))
        axios.get('/api/documents/sign_dates')
        .then(resp => {
          if (resp.status === 200) {
            this.sign_dates = resp.data.filter(data => data.type == 'FML');
          }
        })
      },
      setData() {
        let headers = []
        let data = []

        this.fields = {
          'Estudiante': 'full_name',
          'Cód. de fam.': 'family_id',
          'Cód. Est.': 'student_number',
          'Grado': 'grade_level',
        }

        headers.push(
          { text: 'Familia', align: 'center', value: 'last_name', document: false },
          { text: 'Cód. de fam.', align: 'center', value: 'family_id', document: false },
        )

        this.documents.forEach(document => {
          headers.push(
            {
              text: document.name,
              align: 'center',
              value: document.id,
              document: true,
            }
          )
          this.fields = {
            ...this.fields,
            [`${document.name}`]: `status-${document.id}`,
          }
        })

        this.students.forEach(stu => {
          let dataObj = {
            id: stu.id,
            last_name: stu.last_name,
            family_id: stu.family_id,
            student_number: stu.student_number,
            grade_level: stu.grade_level,
            school_id: stu.school_id,
          }
          let shouldPush = false
          this.documents.forEach(doc => {
            const signedDocument = this.findAssignedDocument(stu.id, doc.id)
            let status = 'not_assigned'
            let doc_id = 0

            if (signedDocument) {
              shouldPush = true
              status = signedDocument[`360_document_status`]
              doc_id = signedDocument[`360_document_id`]
            }
            dataObj = { ...dataObj, [doc.id]: !!signedDocument, [`status-${doc.id}`]: status, [`doc_id-${doc.id}`]: doc_id, }
          })
          if (shouldPush) {
            data.push(dataObj)
          }
        })

        this.loading = false
        this.tableHeaders = headers
        this.tableData = data
      },
      findAssignedDocument(student_id, document_id) {
        return this.signDateEmployees
          .filter(sign => {
            if (this.filter_sign && this.filter_sign !== '') {
              return sign.documents_sign_date_id == this.filter_sign
            }
            return true
          })
          .find(sign =>
            sign.student_id == student_id && sign.school_document_id == document_id
          )
      },
      setFilter() {
        this.setData()
      },
      loadDocument(doc_id) {
        this.dialogDigitalSign = true
        this.action = 'SHOW'
        this.vista_record_id = doc_id
      },
      closeSignDialog() {
        this.action = ''
        this.dialogDigitalSign = false
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/documents/families_sign_report.vue